import { useEffect, useRef, useState } from "react";
import { Col, FormControl, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, Row, Spinner } from "react-bootstrap";
import { BsBuildingsFill, BsDeviceSsdFill, BsFillFileEarmarkTextFill } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import PrivateApi from "../../services/PrivateApiService";
import { useNavigate } from "react-router-dom";
import { AiOutlineCloudDownload } from "react-icons/ai";

const SearchComponent = () => {

    const API = new PrivateApi();
    const navigate = useNavigate();
    const inputRef = useRef(null);
    const [search, setSearch] = useState("");
    const [showSearch, setShowSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSearchListOpen, setIsSearchListOpen] = useState(true);
    const [data, setData] = useState({});

    useEffect(() => {
        document.addEventListener("keydown", searchKeyCombo);
    }, [])


    const searchKeyCombo = (e) => {
        if (e.metaKey && e.which === 75) {
            document.getElementById('search-field').click();
        }
        const { ctrlKey } = e;
        if (ctrlKey && e.which === 75) {
            e.preventDefault();
            document.getElementById('search-field').click();
        }
    }

    const handleEnteronSearch = (e) => {
        if (e.key === "Enter") {
            setIsLoading(true);
            searchForTerm();
        }
    }

    const searchForTerm = () => {
        if ((data && data.term && data.term === search) || search === "") {
            setIsLoading(false);
            return;
        }

        setData([]);
        API.hw_search({ term: search })
            .then(res => {
                setData(res.data);
                setIsSearchListOpen(true);
                setIsLoading(false);
                setTimeout(() => {
                    if (inputRef.current) {
                      inputRef.current.focus(); // Ensure ref exists before calling focus()
                    }
                }, 0);
            })
            .catch(() => {
                setIsLoading(false);
            })
    }

    const handleSearchBtnClick = () => {
        setShowSearch(true); 
        setTimeout(() => {
            if (inputRef.current) {
              inputRef.current.focus(); // Ensure ref exists before calling focus()
            }
        }, 0);
    }

    return (
        <>
            <div
                id="search-field"
                style={{
                    float: "right",
                    width: 200,
                    height: 35,
                    border: "1px solid #dee2e6",
                    borderRadius: 20,
                    textAlign: "start",
                    paddingTop: 3,
                    paddingLeft: 8,
                    cursor: "pointer",
                    ...(showSearch && {
                        background: "#a2c13f",
                        color: "#fff"
                    })
        
                }}
                className="shadow-lg"
                onClick={() => handleSearchBtnClick()}
            >
                <Row>
                    <Col xs="2" xl="2">
                        <FaSearch size={20} />
                    </Col>
                    <Col xs="10">
                        <span style={{ marginLeft: 0, marginTop: 5, userSelect: "none"}}>
                            Suchen {`${navigator.userAgent !== undefined && navigator.userAgent.includes("Macintosh") ? '(Cmd + k)' : '(Strg + k)'}`}
                        </span>
                    </Col>

                </Row>
            </div>

            <Modal show={showSearch} onHide={() => setShowSearch(false)}>
                <ModalBody
                    style={{
                        padding: 10
                    }}
                >
                    <FormControl
                        ref={inputRef}
                        type="search"
                        value={search}
                        placeholder="Gebäude suchen (Bestätigen mit Enter)"
                        disabled={isLoading}
                        onChange={e => setSearch(e.target.value)}
                        onKeyDown={e => handleEnteronSearch(e)}
                    />
                    {isLoading &&
                        <div className="mt-4 text-center" style={{marginLeft: 10}}>
                            <Spinner animation="border" className="text-energo" />
                        </div>
                    }
                    {isSearchListOpen &&
                        <>
                            {data.buildings && data.buildings.length > 0 ?
                                <div className="mt-4">
                                    <b className="text-energo">Gebäude</b>
                                    <ListGroup>
                                        {data.buildings.map(b => (
                                            <ListGroupItem
                                                key={`${b.type}:${b.id}`}
                                                style={{ border: 0 }}
                                                onClick={() => navigate(`gebaeude/anlagen/${b.id}`)}
                                            >
                                                <Row className="align-items-center">
                                                    <Col xl="1"><BsBuildingsFill className="text-muted" size={25} /></Col>
                                                    <Col xl="11">{b.text}</Col>
                                                </Row>
                                                <Row>
                                                    <ul style={{listStyle: "none", marginLeft: 15, marginTop: 4, }}>
                                                        <li key={`anlagen:${b.id}`} className="leadup">
                                                            <a className="link-energo text-dark" href={`/hw/dashboard/gebaeude/anlagen/${b.id}`}>
                                                                <BsDeviceSsdFill className="text-energo" size={20} /> Anlagenverwaltung
                                                            </a>
                                                        </li>
                                                        <li key={`elv:${b.id}`} className="leadup">
                                                            <a className="link-energo text-dark" href={`/hw/dashboard/energieliefervertraege/gebaeude/${b.id}`}>
                                                                <BsFillFileEarmarkTextFill className="text-primary" size={20} /> Energielieferverträge
                                                            </a>
                                                        </li>
                                                        <li key={`dokumente:${b.id}`} className="leadup">
                                                            <a className="link-energo text-dark" href={`/hw/dashboard/gebaeude/dokumente/${b.id}`}>
                                                                <AiOutlineCloudDownload className="text-violet" size={20} /> Dokumente
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </Row>
                                            </ListGroupItem>
                                        ))}
                                    </ListGroup>
                                    {data.has_more &&
                                        <div className="text-center">
                                            <small style={{userSelect: "none"}} className="text-muted">Mehr vorhanden. Bitte verfeinern Sie die Suche.</small>
                                        </div>
                                    }
                                </div>:

                                data.buildings && data.buildings.length === 0 ?
                                    <div className="mt-4 mb-4 text-center" hidden={isLoading}>
                                        <small style={{userSelect: "none"}} className="text-muted">Keine Treffer</small>
                                    </div>
                                :
                                    <div className="mt-4 mb-4 text-center" hidden={isLoading}>
                                        <small style={{userSelect: "none"}} className="text-muted">Keine aktuellen Suchanfragen</small>
                                    </div>
                            }
                        </>
                    }

                </ModalBody>
            </Modal>
        </>
    )
}
export default SearchComponent;